import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTallyI18n } from '../i18n/tally.js'

export function BottomNav() {
  const { pathname } = useLocation()
  const navigate     = useNavigate()
  const t            = useTallyI18n()
  const [moreOpen, setMoreOpen] = useState(false)

  const isActive = (base) => pathname === base || pathname.startsWith(base + '/')
  // "More" lights up when one of the pages it holds is open
  const moreActive = isActive('/categories') || isActive('/converter')

  useEffect(() => { setMoreOpen(false) }, [pathname])

  return (
    <>
      {moreOpen && <div className="bnav-more-backdrop" onClick={() => setMoreOpen(false)} />}
      <nav className="bottom-nav">
        <button
          className={`bnav-btn${isActive('/dashboard') ? ' active' : ''}`}
          onClick={() => navigate('/dashboard')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 10.5 12 3l9 7.5" />
            <path d="M5 9.5V21h14V9.5" />
            <path d="M10 21v-6h4v6" />
          </svg>
          {t.nav.overview}
        </button>
        <button
          className={`bnav-btn${isActive('/transactions') ? ' active' : ''}`}
          onClick={() => navigate('/transactions')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 7h13l-3-3" />
            <path d="M21 17H8l3 3" />
          </svg>
          {t.nav.transactions}
        </button>
        <button
          className={`bnav-btn${isActive('/stats') ? ' active' : ''}`}
          onClick={() => navigate('/stats')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 3v18h18" />
            <path d="M7 14l4-4 4 4 5-5" />
          </svg>
          {t.nav.stats}
        </button>
        <button
          className={`bnav-btn${moreActive || moreOpen ? ' active' : ''}`}
          onClick={() => setMoreOpen(v => !v)}
          aria-haspopup="menu"
          aria-expanded={moreOpen}
        >
          <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <circle cx="5" cy="12" r="2" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="19" cy="12" r="2" />
          </svg>
          {t.nav.more}
        </button>

        {moreOpen && (
          <div className="bnav-more-menu" role="menu">
            <button
              role="menuitem"
              className={`bnav-more-item${isActive('/categories') ? ' active' : ''}`}
              onClick={() => navigate('/categories')}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
              </svg>
              {t.nav.categories}
            </button>
            <button
              role="menuitem"
              className={`bnav-more-item${isActive('/converter') ? ' active' : ''}`}
              onClick={() => navigate('/converter')}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 7h13l-3-3" />
                <path d="M17 17H4l3 3" />
              </svg>
              {t.nav.converter}
            </button>
          </div>
        )}
      </nav>
    </>
  )
}
